import React, { useState } from 'react'
import { Form } from 'react-bootstrap';
import styles from './specialNoteDetails.module.scss';
import { Formik } from 'formik';
import * as yup from 'yup';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { CustomTextArea } from '../../../../shared/customTextArea';
import { CustomButton } from '../../../../shared/customButton';

function SpecialNoteDetails(props) {

    //yup validations
    const schema = yup.object({
        note: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required').nullable(),
    });

    return (
        <div>
            <Formik
                validationSchema={schema}
                enableReinitialize
                onSubmit={(values) => props.onSubmitNoteData(values)}
                initialValues={{ note: props.noteData.note }}
                >

                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    submitCount
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <CustomTextArea
                            label="Note"
                            name="note"
                            values={values.note}
                            errorMessage={errors.note}
                            handleChange={handleChange}
                            isInvalid={submitCount > 0 && !!errors.note}
                            remainingCount={(values.note).length}
                            maxLength={300}
                        />
                        <hr className={styles.dividerLine} />
                        <div className='d-flex flex-row-reverse'>
                            <div className={styles.navigateBtnCol}>
                                {<CustomButton
                                    id="pipeline_name_confirm"
                                    buttonType="submit"
                                    label="Next"
                                    type="primaryBtn"

                                />}
                            </div>
                        </div>

                    </Form>
                )}
            </Formik>
        </div >
    )
}

export default SpecialNoteDetails;
